import { ChevronsUpDown, SquarePen, Trash } from "lucide-react";
import React, { useState } from "react";
import { can_visit, insurance_name } from "../../helpers";
import Badge from "../UI/Badge";
import DeleteModal from "../Modal/DeleteModal";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
  width: '230px'
};

export default function PromptDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    setEditModalOpen = () => {},
    setEditData = () => {},
    handleDeleteRecord = () => {},
    handlePromptView = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
  } = props;

  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const [orderBy, setOrderBy] = useState();

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };


  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th>Practice</th>
              <th>Location</th>
              <th>Speciality</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>

                    <td onClick={() => {handlePromptView(item?.id);}}>
                      {item?.practice_name}
                    </td>
                    <td onClick={() => {handlePromptView(item?.id);}}>
                      {item?.location_name}
                    </td>
                    <td onClick={() => {handlePromptView(item?.id);}}>
                      {item?.speciality_name}
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        {can_visit('administrator_prompt_edit') && (
                          <button
                            type="button"
                            className="docpro_icon_btn last_btn_tip"
                            onClick={() => {
                              setEditModalOpen(true);
                              setEditData(item);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <SquarePen width={20} height={20} />
                            <span className="docpro_tip">Edit</span>
                          </button>
                        )}
                        {can_visit('administrator_prompt_delete') && (
                          <button
                            type="button"
                            className="docpro_icon_btn docpro_icon_btn_red last_btn_tip"
                            onClick={() => {
                              setDeleteRecord(item);
                              setActiveDeleteModal(true);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Trash width={20} height={20} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="4">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="4">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name="this prompt"
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
